import {
  VuexModule,
  Module,
  Action,
  Mutation,
  getModule,
} from "vuex-module-decorators";
import store from "@/store";
import { asyncRouterHandle } from "@/utils/asyncRouter";
import { getAsyncMenu } from "@/api/menu";

// 额外路由，详情参照文档
const exRouter: any = {
  interactionManage: [
    {
      path: "homework_add",
      name: "addAfter",
      hidden: true,
      meta: {
        title: "添加练习",
      },
      component: "view/interactionManagement/afterClass/addAfter/index.vue",
    },
    {
      path: "homework_detail",
      name: "afterDetails",
      hidden: true,
      meta: {
        title: "练习详情",
      },
      component: "view/interactionManagement/afterClass/afterDetails/index.vue",
    },
    {
      path: "comment_detail",
      name: "commentDetail",
      hidden: true,
      meta: {
        title: "课堂点评详细",
      },
      component:
        "view/interactionManagement/classroomComment/commentDetail/index.vue",
    },
    {
      path: "comment",
      name: "comment",
      hidden: true,
      meta: {
        title: "点评",
      },
      component:
        "view/interactionManagement/classroomComment/comment/index.vue",
    },
  ],
  storeManage: [
    {
      path: "employee_detail",
      name: "editEmployee",
      hidden: true,
      meta: {
        title: "员工详情",
      },
      component: "view/storeManagement/employeeManage/editEmployee/index.vue",
    },
  ],
  financeCenter: [
    {
      path: "order_edit",
      name: "orderManageEdit",
      hidden: true,
      meta: {
        title: "订单编辑",
      },
      component: "view/financeCenter/orderManagement/orderEdit/index.vue",
    },
    {
      path: "order_detail",
      name: "orderManageDetail",
      hidden: true,
      meta: {
        title: "订单详情",
      },
      component: "view/financeCenter/orderManagement/orderDetail/index.vue",
    },
    {
      path: "settlement_detail",
      name: "settlementDetail",
      hidden: true,
      meta: {
        title: "工资结算详情",
      },
      component:
        "view/financeCenter/salary/tabStore/settlementDetail/index.vue",
    },
    {
      path: "staff_performance_detail",
      name: "staffPerformanceDetail",
      hidden: true,
      meta: {
        title: "员工绩效详情",
      },
      component:
        "view/financeCenter/salary/tabStore/settlementDetail/performanceDetail.vue",
    },
    {
      path: "staff_salary",
      name: "staffSalary",
      hidden: true,
      meta: {
        title: "设置员工工资",
      },
      component: "view/financeCenter/salary/tabStore/staffSalary/index.vue",
    },
    {
      path: "staff_salary_detail",
      name: "staffSalaryDetail",
      hidden: true,
      meta: {
        title: "设置员工工资详情",
      },
      component:
        "view/financeCenter/salary/tabStore/staffSalary/detail/index.vue",
    },
    {
      path: "approve_log_detail",
      name: "approveLogDetail",
      hidden: true,
      meta: {
        title: "审批详情",
      },
      component: "view/financeCenter/approveLog/logDetail/index.vue",
    },
    {
      path: "withdrawal",
      name: "storeWalletWithdrawal",
      hidden: true,
      meta: {
        title: "我要提现",
      },
      component: "view/financeCenter/storeWallet/withdrawal/index.vue",
    },
    {
      path: "agreement",
      name: "storeWalletAgreement",
      hidden: true,
      meta: {
        title: "",
      },
      component: "view/financeCenter/storeWallet/onlinePay/agreement.vue",
    },
    {
      path: "assistment",
      name: "storeWalletAssistment",
      hidden: true,
      meta: {
        title: "",
      },
      component: "view/financeCenter/storeWallet/onlinePay/assistment.vue",
    },
  ],
  teachManage: [
    {
      path: "class_detail",
      name: "classManageDetail",
      hidden: true,
      meta: {
        title: "班级详情",
      },
      component: "view/teachManagement/classManagement/classDetail/index.vue",
    },
    {
      path: "course_detail",
      name: "storeCourseDetail",
      hidden: true,
      meta: {
        title: "课程详情",
      },
      component: "view/teachManagement/storeCourse/storeCourseDetail/index.vue",
    },
    {
      path: "package_detail",
      name: "storePackageDetail",
      hidden: true,
      meta: {
        title: "课包详情",
      },
      component:
        "view/teachManagement/storeCourse/storePackageDetail/index.vue",
    },
    {
      path: "combo_detail",
      name: "storeSetDetail",
      hidden: true,
      meta: {
        title: "套餐详情",
      },
      component: "view/teachManagement/storeCourse/storeSetDetail/index.vue",
    },
    {
      path: "teacher_detail",
      name: "teacherDetails",
      hidden: true,
      meta: {
        title: "教师详情",
      },
      component: "view/teachManagement/teacherManage/teacherDetails/index.vue",
    },
    {
      path: "student_detail",
      name: "studyDetails",
      hidden: true,
      meta: {
        title: "学员详情",
      },
      component: "view/teachManagement/studentManage/studyDetails/index.vue",
    },
    {
      path: "roll_call_detail",
      name: "rollCallDetails",
      hidden: true,
      meta: {
        title: "点名详情",
      },
      component:
        "view/teachManagement/rollCallRecord/rollCallDetails/index.vue",
    },
    {
      path: "lesson_detail",
      name: "classTimeDetails",
      hidden: true,
      meta: {
        title: "课次详情",
      },
      component:
        "view/teachManagement/rollCallRecord/classTimeDetails/index.vue",
    },
    {
      path: "leave_appli_detail",
      name: "leaveAppliDetails",
      hidden: true,
      meta: {
        title: "添加请假学员",
      },
      component:
        "view/teachManagement/rollCallRecord/leaveAppliDetails/index.vue",
    },
    {
      path: "buy_confirm",
      name: "buyCourseConfirm",
      hidden: true,
      meta: {
        title: "报名缴费",
      },
      component: "view/teachManagement/buyCourseConfirm/index.vue",
    },
    {
      path: "order_transfer",
      name: "orderTransfer",
      hidden: true,
      meta: {
        title: "学员转课",
      },
      component: "view/teachManagement/orderTransfer/index.vue",
    },
    {
      path: "order_refund",
      name: "orderRefund",
      hidden: true,
      meta: {
        title: "学员退课",
      },
      component: "view/teachManagement/orderRefund/index.vue",
    },
    {
      path: "repair_class",
      name: "repairClass",
      hidden: true,
      meta: {
        title: "补课课表",
      },
      component:
        "view/teachManagement/rollCallRecord/makeUpLessonClass/index.vue",
    },
    {
      path: "graduation_student",
      name: "graduationStudent",
      hidden: true,
      meta: {
        title: "结业学员",
      },
      component: "view/statistics/student/graduationStudent.vue",
    },
  ],
  integral: [
    {
      path: "goods_detail",
      name: "integralGoodsDetail",
      hidden: true,
      meta: {
        title: "商品详情",
      },
      component: "view/integral/goods/detail.vue",
    },
  ],
  recruit: [
    {
      path: "experience_sechdule",
      name: "experienceSechdule",
      hidden: true,
      meta: {
        title: "预览体验课",
      },
      component: "view/recruit/sechdule/index.vue",
    },
  ],
  marketingCenter: [
    {
      path: "add_activity",
      name: "addActivity",
      hidden: true,
      meta: {
        title: "添加活动",
      },
      component:
        "view/marketingCenter/activityManagement/activityList/addActivity.vue",
    },
    {
      path: "promotion_code",
      name: "promotionCode",
      hidden: true,
      meta: {
        title: "推广码管理",
      },
      component:
        "view/marketingCenter/activityManagement/promotionCode/index.vue",
    },
    {
      path: "view_list",
      name: "viewList",
      hidden: true,
      meta: {
        title: "查看意向名单",
      },
      component: "view/marketingCenter/activityManagement/viewList/index.vue",
    },
    {
      path: "promotion_list",
      name: "promotionList",
      hidden: true,
      meta: {
        title: "推广名单数",
      },
      component: "view/marketingCenter/marketingPromotion/promotionList.vue",
    },
    {
      path: "sales_amount_detail",
      name: "salesAmountDetail",
      hidden: true,
      meta: {
        title: "销售金额明细",
      },
      component:
        "view/marketingCenter/marketingPromotion/salesAmountDetail.vue",
    },
  ],
};
// 插入额外路由
const insetExRouter = (routes: any[]) => {
  routes &&
    routes.map((item) => {
      // 插入额外路由
      if (exRouter[item.name]) {
        item.children = [...item.children, ...exRouter[item.name]];
      }
      if (item.children && item.children.length > 0) {
        insetExRouter(item.children);
      }
    });
};

// 路由格式化
const formatRouter = (routes: any[]) => {
  routes &&
    routes.map((item) => {
      // 过滤功能项
      if (item.children && item.children.length > 0) {
        item.children = item.children.filter((it: any) => {
          return it.info.is_menu === 1;
        });
      }
      item.path = item.info.route_path;
      item.component = item.info.component;
      item.meta = {
        title: item.name,
        icon: item.info.icon,
      };
      item.name = item.info.route_name;
      item.hidden = item.info.status === 2;
      delete item.info;
      delete item.is_select;
      delete item.menu_id;
      delete item.menu_pid;
      if (item.children && item.children.length > 0) {
        formatRouter(item.children);
      }
    });
};

export interface IRouterState {
  asyncRouters: any[];
}

@Module({ dynamic: true, namespaced: true, store, name: "router" })
class Router extends VuexModule implements IRouterState {
  asyncRouters: any[] = [];

  /*
    ! getters
  */

  /*
    ! mutations
  */

  @Mutation
  public SET_ROUTER(routers: any[]) {
    this.asyncRouters = routers;
  }
  @Mutation
  public CLEAR_ROUTER() {
    const baseRouter: any[] = [
      {
        path: "/layout",
        meta: {
          title: "首页",
        },
        component: "view/layout/index.vue",
        children: [],
      },
    ];
    baseRouter.push({
      path: "*",
      redirect: "/layout/404",
    });
    asyncRouterHandle(baseRouter);
    this.asyncRouters = baseRouter;
  }

  /*
    ! actions
  */

  @Action({ rawError: true })
  public async SetAsyncRouter() {
    // 最外层为layout
    const baseRouter: any[] = [
      {
        path: "/layout",
        // name: 'layout',
        meta: {
          title: "首页",
        },
        component: "view/layout/index.vue",
        children: [],
      },
    ];
    // 动态路由
    const asyncRouterRes = await getAsyncMenu();
    const asyncRouter = asyncRouterRes.data.list || [];
    formatRouter(asyncRouter);
    insetExRouter(asyncRouter);
    asyncRouter.push({
      path: "404",
      name: "404",
      hidden: true,
      meta: {
        title: "迷路了*。*",
      },
      component: "view/error/index.vue",
    });
    asyncRouter.push({
      path: "search_result",
      name: "searchResult",
      hidden: true,
      meta: {
        title: "搜索结果",
      },
      component: "view/searchResult/index.vue",
    });
    asyncRouter.push({
      path: "/",
      redirect: "/layout/home",
    });
    baseRouter[0].children = asyncRouter;
    baseRouter.push({
      path: "*",
      redirect: "/layout/404",
    });
    // 根据路由信息批量获取对应的vue组件
    asyncRouterHandle(baseRouter);
    this.SET_ROUTER(baseRouter);
    return true;
  }
}

export const RouterModule = getModule(Router);
